import { Controller } from '@hotwired/stimulus'

export default class RiskFilterCountController extends Controller {
  static targets = [
    'riskTypeCount', 'statusCount', 'ownerCount', 'inherentRiskCount', 'residualRiskCount',
    'riskTypeCheckbox', 'statusCheckbox', 'ownerCheckbox', 'inherentRiskCheckbox', 'residualRiskCheckbox'
  ]

  declare readonly riskTypeCountTarget: HTMLElement
  declare readonly statusCountTarget: HTMLElement
  declare readonly ownerCountTarget: HTMLElement
  declare readonly inherentRiskCountTarget: HTMLElement
  declare readonly residualRiskCountTarget: HTMLElement

  declare readonly hasRiskTypeCountTarget: boolean
  declare readonly hasStatusCountTarget: boolean
  declare readonly hasOwnerCountTarget: boolean
  declare readonly hasInherentRiskCountTarget: boolean
  declare readonly hasResidualRiskCountTarget: boolean

  declare readonly riskTypeCheckboxTargets: HTMLInputElement[]
  declare readonly statusCheckboxTargets: HTMLInputElement[]
  declare readonly ownerCheckboxTargets: HTMLInputElement[]
  declare readonly inherentRiskCheckboxTargets: HTMLInputElement[]
  declare readonly residualRiskCheckboxTargets: HTMLInputElement[]

  connect (): void {
    this.updateAllCounts()
  }

  updateRiskTypeCount (): void {
    if (this.hasRiskTypeCountTarget) {
      this.updateCount(this.riskTypeCheckboxTargets, this.riskTypeCountTarget)
    }
  }

  updateStatusCount (): void {
    if (this.hasStatusCountTarget) {
      this.updateCount(this.statusCheckboxTargets, this.statusCountTarget)
    }
  }

  updateOwnerCount (): void {
    if (this.hasOwnerCountTarget) {
      this.updateCount(this.ownerCheckboxTargets, this.ownerCountTarget)
    }
  }

  updateInherentRiskCount (): void {
    if (this.hasInherentRiskCountTarget) {
      this.updateCount(this.inherentRiskCheckboxTargets, this.inherentRiskCountTarget)
    }
  }

  updateResidualRiskCount (): void {
    if (this.hasResidualRiskCountTarget) {
      this.updateCount(this.residualRiskCheckboxTargets, this.residualRiskCountTarget)
    }
  }

  updateAllCounts (): void {
    this.updateRiskTypeCount()
    this.updateStatusCount()
    this.updateOwnerCount()
    this.updateInherentRiskCount()
    this.updateResidualRiskCount()
  }

  private updateCount (checkboxes: HTMLInputElement[], target: HTMLElement): void {
    const count = checkboxes.filter(checkbox => checkbox.checked).length
    target.textContent = count.toString()
  }
}
